import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import getLanguage from "../../utils/getLanguage";

const defaultLang = {
  common: {
    ok: "OK",
    cancel: "Cancel"
  }
};

let lang = defaultLang;
try {
  const resolved = await getLanguage();
  if (resolved && typeof resolved === "object") {
    lang = resolved;
  }
} catch (e) {
  // keep defaultLang on error
}

const themeConfig = {
  customClass: {
    popup: [
      "!bg-card",
      "!text-muted-foreground",
      "rounded-lg",
      "shadow-lg",
      "p-6",
      "min-w-[320px]", "max-w-[400px]",
      "[&_a]:text-primary [&_a]:underline [&_a]:font-medium",
    ].join(" "),
    header: ["p-6", "pb-0"].join(" "),
    title: ["text-xl","font-semibold","mb-2","leading-snug"].join(" "),
    htmlContainer: ["text-muted-foreground","text-sm","leading-relaxed","mb-5"].join(" "),
    actions: ["flex","justify-end","gap-3","w-full","m-0"].join(" "),
    confirmButton: [
      "bg-primary","text-primary-foreground","rounded-md",
      "text-sm","font-medium","py-3","px-8",
      "transition-colors","hover:bg-primary/80"
    ].join(" "),
    cancelButton: [
      "bg-transparent","text-primary","rounded-md",
      "text-sm","font-medium","py-3","px-8",
      "transition-colors","hover:bg-gray-300/70"
    ].join(" ")
  },
  confirmButtonText: lang.common?.ok ?? defaultLang.common.ok,
  cancelButtonText: lang.common?.cancel ?? defaultLang.common.cancel,
  buttonsStyling: false,
  reverseButtons: false,
  allowEscapeKey: true 
};
// กำหนด config เป็น default
export const MySwal = withReactContent(Swal.mixin({
  ...themeConfig,
  allowOutsideClick: true,
  customClass: {
    ...themeConfig.customClass,
    container: "backdrop-blur-md",
  }
}));

export const AppleToast = Swal.mixin({
  ...themeConfig,
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timerProgressBar: true,
  customClass: {
    ...themeConfig.customClass,
    popup: [
      themeConfig.customClass.popup,
      "animate-[slideInFromTop_0.4s_cubic-bezier(0.25,0.46,0.45,0.94)]"
    ].join(" "),
  },
});
